import { useState, useEffect } from 'react';
import { auth } from '../../services/firebase';
import { fetchUserCalendarEvents } from '../../utils/calendarUtils';

export const useCalendarEvents = () => {
  const user = auth.currentUser;
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  // Load events for the current user (buyer or seller) using calendarUtils
  useEffect(() => {
    const loadEvents = async () => {
      if (!user) return;
      
      setLoading(true);
      try {
        const userEvents = await fetchUserCalendarEvents(user.uid);
        setEvents(userEvents);
      } catch (error) {
        setEvents([]);
      } finally {
        setLoading(false);
      }
    };

    loadEvents();
  }, [user]);

  // Filter events for selected date and only show accepted
  const dateStr = selectedDate.toISOString().slice(0, 10);
  const dayEvents = events.filter(e => e.date === dateStr && e.status === 'accepted');

  // Create event counts by date for calendar visual indicators
  const eventsByDate = events
    .filter(e => e.status === 'accepted')
    .reduce((acc, event) => {
      const date = event.date;
      if (!acc[date]) {
        acc[date] = [];
      }
      acc[date].push(event);
      return acc;
    }, {});

  // Find the most recently added meeting (latest createdAt)
  const latestMeeting = events
    .filter(e => e.status === 'accepted' && e.createdAt)
    .sort((a, b) => {
      const aTime = a.createdAt?.seconds || 0;
      const bTime = b.createdAt?.seconds || 0;
      return bTime - aTime;
    })[0];

  const latestMeetingDate = latestMeeting?.date || null;

  return {
    user,
    selectedDate,
    setSelectedDate,
    events,
    dayEvents,
    loading,
    dateStr,
    eventsByDate,
    latestMeetingDate
  };
};